import React from 'react';
import { Facebook, Instagram, Linkedin, Mail, Phone, MapPin } from 'lucide-react';

const Footer = () => {
  const currentYear = new Date().getFullYear();

  return (
    <footer className="bg-[#0f172a] text-gray-300">
      <div className="container mx-auto px-4 lg:px-8 py-16">
        <div className="grid md:grid-cols-2 lg:grid-cols-4 gap-12 mb-12">
          {/* Company Info */}
          <div>
            <div className="mb-6">
              <h3 className="text-3xl font-bold" style={{ fontFamily: "'Playfair Display', serif" }}>
                <span className="text-white">Dekor Art </span>
                <span className="text-[#d4af37]">gradnja</span>
              </h3>
            </div>
            <p className="text-gray-400 mb-6 leading-relaxed">
              Vodeća građevinska tvrtka osnovana 2024. godine, s timom iskusnih stručnjaka.
            </p>
            <div className="flex gap-4">
              <a 
                href="#" 
                className="w-10 h-10 bg-[#1e293b] rounded-lg flex items-center justify-center hover:bg-[#d4af37] transition-colors"
                aria-label="Facebook"
              >
                <Facebook className="w-5 h-5" />
              </a>
              <a 
                href="#" 
                className="w-10 h-10 bg-[#1e293b] rounded-lg flex items-center justify-center hover:bg-[#d4af37] transition-colors"
                aria-label="Instagram"
              >
                <Instagram className="w-5 h-5" />
              </a>
              <a 
                href="#" 
                className="w-10 h-10 bg-[#1e293b] rounded-lg flex items-center justify-center hover:bg-[#d4af37] transition-colors"
                aria-label="LinkedIn"
              >
                <Linkedin className="w-5 h-5" />
              </a>
            </div>
          </div>

          {/* Quick Links */}
          <div>
            <h4 className="text-white text-lg font-bold mb-6">Brzi Linkovi</h4>
            <ul className="space-y-3">
              {[
                { name: 'Početna', href: '#home' },
                { name: 'O Nama', href: '#about' },
                { name: 'Usluge', href: '#services' },
                { name: 'Projekti', href: '#projects' },
                { name: 'Kontakt', href: '#contact' }
              ].map((link) => (
                <li key={link.name}>
                  <a 
                    href={link.href} 
                    className="text-gray-400 hover:text-[#d4af37] transition-colors"
                  >
                    {link.name}
                  </a>
                </li>
              ))}
            </ul>
          </div>

          {/* Services */}
          <div>
            <h4 className="text-white text-lg font-bold mb-6">Naše Usluge</h4>
            <ul className="space-y-3">
              {[
                'Fasadni Radovi',
                'Suha Gradnja',
                'Soboslikarski Radovi',
                'Adaptacije Ključ u Ruke',
                'Keramičarski Radovi',
                'Postave Laminata',
                'Postava Kocki i Betonaža'
              ].map((service) => (
                <li key={service}>
                  <a 
                    href="#services" 
                    className="text-gray-400 hover:text-[#d4af37] transition-colors"
                  >
                    {service}
                  </a>
                </li>
              ))}
            </ul>
          </div>

          {/* Contact Info */}
          <div>
            <h4 className="text-white text-lg font-bold mb-6">Kontakt</h4>
            <ul className="space-y-4">
              <li className="flex items-start gap-3">
                <MapPin className="w-5 h-5 text-[#d4af37] flex-shrink-0 mt-1" />
                <span className="text-gray-400">
                  Davora Bašića 13<br />
                  10290 Zaprešić, Hrvatska
                </span>
              </li>
              <li className="flex items-center gap-3">
                <Phone className="w-5 h-5 text-[#d4af37] flex-shrink-0" />
                <span className="text-gray-400">097 641 9996</span>
              </li>
              <li className="flex items-center gap-3">
                <Mail className="w-5 h-5 text-[#d4af37] flex-shrink-0" />
                <span className="text-gray-400">dekor.art.gradnja@gmail.com</span>
              </li>
            </ul>
          </div>
        </div>

        {/* Bottom Bar */}
        <div className="border-t border-gray-800 pt-8">
          <div className="flex flex-col md:flex-row justify-between items-center gap-4">
            <p className="text-gray-400 text-sm">
              &copy; {currentYear} Dekor Art gradnja. Sva prava pridržana.
            </p>
            <div className="flex gap-6 text-sm">
              <a href="#" className="text-gray-400 hover:text-[#d4af37] transition-colors">
                Politika Privatnosti
              </a>
              <a href="#" className="text-gray-400 hover:text-[#d4af37] transition-colors">
                Uvjeti Korištenja
              </a>
            </div>
          </div>
        </div>
      </div>
    </footer>
  );
};

export default Footer;